import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './css/News.css';
import QaNavBox from '../components/QaNavbox';
import newsData from '../components/NewsData';

const ITEMS_PER_PAGE = 10;

const News: React.FC = () => {
    const [currentPage, setCurrentPage] = useState(1);

    const newsItems = [...newsData].reverse().map((news) => ({
        id: parseInt(news.id),
        title: news.title,
        excerpt: news.summary,
        image: news.image,
        url: `/news/${news.id}`
    }));

    const totalPages = Math.ceil(newsItems.length / ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const currentItems = newsItems.slice(startIndex, startIndex + ITEMS_PER_PAGE);

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="news-page-container">
            <QaNavBox />
            <div className="news-content-area">
                <div className="news-list-container">
                    {currentItems.map((news) => (
                        <NewsCard
                            key={news.id}
                            id={news.id}
                            title={news.title}
                            excerpt={news.excerpt}
                            image={news.image}
                            url={news.url}
                        />
                    ))}
                </div>
                {totalPages > 1 && (
                    <div className="news-pagination">
                        <button
                            className="pagination-btn"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            &laquo;
                        </button>
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                            <button
                                key={page}
                                className={`pagination-btn${currentPage === page ? ' active' : ''}`}
                                onClick={() => handlePageChange(page)}
                            >
                                {page}
                            </button>
                        ))}
                        <button
                            className="pagination-btn"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            &raquo;
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

interface NewsCardProps {
    id: number;
    title: string;
    // date: string;
    excerpt: string;
    image: string;
    url: string;
}

const NewsCard: React.FC<NewsCardProps> = ({ id, title, excerpt, image, url }) => {
    const handleReadMoreClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
    };

    return (
        <Link to={url} className="news-item-card">
            <div className="news-item-content">
                <div className="news-item-text">
                    {/* <div className="news-item-header">
                        <span className="news-item-date">{date}</span>
                    </div> */}
                    <h3 className="news-item-title">{title}</h3>
                    <p className="news-item-excerpt">{excerpt}</p>
                    <div
                        className="news-item-readmore"
                        onClick={handleReadMoreClick}
                    >
                        Дэлгэрэнгүй
                    </div>
                </div>
                <div className="news-item-image-wrapper">
                    <img src={image} alt={title} className="news-item-image" />
                </div>
            </div>
        </Link>
    );
};

export default News;